
function landing(){
    if(document.body.classList.contains('landing')){
        // click on menuItems on Mmenu
        const apiMenu = window.menu.API;
        // const apiMenu = menu.API;
        const menuItems = document.querySelectorAll('.mm-listitem__text');
        menuItems.forEach(item => {
            item.addEventListener('click', () => {
                apiMenu.close();
            });
        });

        // Mmenu.options.onClick.close = true;

        function highlightMenuItems() {
            const scrollPosition = window.scrollY;
            const sections = document.querySelectorAll('.section');

            for (let i = 0; i < sections.length; i++) {
                const section = sections[i];
                // Получаем позицию начала и конца блока section
                const sectionStart = section.offsetTop ;
                const sectionEnd = sectionStart + section.offsetHeight;
                const offsetSection = parseInt(getComputedStyle(section).scrollMarginTop);

                // Если текущая позиция скролла находится в пределах блока section,
                // выделяем пункты li в соответствующем меню
                // if (scrollPosition >= sectionStart && scrollPosition < sectionEnd) {
                if (scrollPosition >= sectionStart - offsetSection - 1 && scrollPosition < sectionEnd) { // учтем offset, а также вычтем 1 для того чтобы отсечь десятые
                    let menuId;

                    if(section.hasAttribute('id')){
                        menuId = section.getAttribute('id');
                    } else if(section.parentElement.querySelector('.tpl-anchor')) {
                        section.parentElement.querySelector('.tpl-anchor').getAttribute('id');
                    }

                    if(menuId){
                        const menu = document.querySelector(`.menu-top__link[href="#${menuId}"]`);
                        const menuList = menu.closest('.menu-top_list');

                        if(menuList){
                            const menuItems = menuList.querySelectorAll('.menu-top_item');
                            for (let j = 0; j < menuItems.length; j++) {
                                menuItems[j].classList.remove('menu-top_item_selected');
                            }
                            menu.parentElement.classList.add('menu-top_item_selected');
                        }

                        const menuMobile = document.querySelector(`.mm-menu [href="#${menuId}"]`);
                        const menuMobileItems = menuMobile.closest('ul').querySelectorAll('li');

                        for (let j = 0; j < menuMobileItems.length; j++) {
                            menuMobileItems[j].classList.remove('mm-listitem--selected');
                        }
                        menuMobile.parentElement.classList.add('mm-listitem--selected');
                    }

                }
            }
        }
        window.addEventListener('scroll', highlightMenuItems);
    }
}
export default landing;